import $ from 'jquery'

var ratingWidget = function($element) {

  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      url,
      selectedValue,
      $ratingLink,
      isRatingProcessing = false;

  /* PRIVATE METHODS */

  // constructor
  function init() {
    $ratingLink = $('.w-flex-ratings a', $mainContainer);
    url = $mainContainer.data('url');
    selectedValue = $mainContainer.data('selected');

    if (selectedValue > 0) $ratingLink.eq(selectedValue - 1).addClass('selected light').prevAll().addClass('light');

    bindDomEvents();
  }

  function bindDomEvents() {
    $ratingLink.on('click', function(e) {
      e.preventDefault();
      if(isRatingProcessing){
        return;
      }
      var $this = $(this);
      var xhrData = {
        url: url,
        type: 'POST',
        data: {
          value: $this.data('value')
        },
        dataType: 'json'
      };

      var callbacks = {
        afterSuccess: function(response) {
          if (SOPHIA.xhrHasErrors(response) === false) {
            $this.siblings('a').removeClass('selected').removeClass('light');
            $this.addClass('selected');
            $this.addClass('light');
            $this.prevAll().addClass('light');
            $mainContainer.data('selected', $this.data('value'));
          }
        },
        afterComplete: function(){
          isRatingProcessing = false;
        }
      };

      isRatingProcessing = true;
      SOPHIA.sendXHR(xhrData, callbacks);
    });
  }

  // run constructor
  init();

  /* PUBLIC METHODS */

  return {
    // public methods go here
  };
};

// jQuery plugin method
$.fn.ratingWidget = function() {
  return this.each(function() {
    var $this = $(this);

    // Store plugin object in this element's data if it doesn't already exist
    if (!$this.data('ratingWidget')) {
      $this.data('ratingWidget', ratingWidget($this));
    }
  });
};
